export type PlaySessionKind = "daily" | "beta";

export type PlaySessionConfig = {
  kind: PlaySessionKind;
  mapId: string;
  showLeaderboardLink: boolean;
  showMapRating: boolean;
};

export function playSessionConfig({
  kind,
  mapId,
}: {
  kind: PlaySessionKind;
  mapId: string;
}): PlaySessionConfig {
  if (kind === "beta") {
    return {
      kind,
      mapId,
      showLeaderboardLink: false,
      showMapRating: false,
    };
  }
  return {
    kind,
    mapId,
    showLeaderboardLink: true,
    showMapRating: true,
  };
}
